export default {
  alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
  box: {
    clients: '64197155567'
  },
  google: {
    colors: {
      '1': '#7a86cb',
      '2': '#33b679',
      '3': '#8e24aa',
      '4': '#e67c73',
      '5': '#f6nf25',
      '6': '#f4521d',
      '7': '#039be5',
      '8': '#616161',
      '9': '#3f51b5',
      '10': '#0a8043',
      '11': '#d50001'
    },
    colorIds: {
      default: '7',
      done: '8'
    }
  },
  files: {
    FILE: {
      icon: 'fa-file',
      color: 'gray--text text--darken-2'
    },
    DOC: {
      icon: 'fa-file-word',
      color: 'blue--text text--darken-3'
    },
    DOCX: {
      icon: 'fa-file-word',
      color: 'blue--text text--darken-3'
    },
    XLS: {
      icon: 'fa-file-excel',
      color: 'green--text text--darken-3'
    },
    XLSX: {
      icon: 'fa-file-excel',
      color: 'green--text text--darken-3'
    },
    PPT: {
      icon: 'fa-file-powerpoint',
      color: 'orange--text text--darken-3'
    },
    PPTX: {
      icon: 'fa-file-powerpoint',
      color: 'orange--text text--darken-3'
    },
    PDF: {
      icon: 'fa-file-pdf',
      color: 'red--text text--darken-3'
    },
    PNG: {
      icon: 'fa-file-image',
      color: 'grey--text text--darken-4'
    },
    JPG: {
      icon: 'fa-file-image',
      color: 'grey--text text--darken-4'
    },
    JPEG: {
      icon: 'fa-file-image',
      color: 'grey--text text--darken-4'
    },
    BMP: {
      icon: 'fa-file-image',
      color: 'grey--text text--darken-4'
    },
    GIF: {
      icon: 'fa-file-image',
      color: 'grey--text text--darken-4'
    },
    TXT: {
      icon: 'fa-file-alt',
      color: 'blue-grey--text text--darken-1'
    },
    MD: {
      icon: 'fa-file-invoice',
      color: 'blue-grey--text text--darken-1'
    },
    ZIP: {
      icon: 'fa-file-archive',
      color: 'brown--text'
    },
    EML: {
      icon: 'fa-envelope',
      color: 'blue--text text--darken-1'
    }
  },
  order: {
    icons: {
      dir: {
        asc: 'fal fa-sort-numeric-down',
        desc: 'fal fa-sort-numeric-up'
      }
    }
  },
  belongs: {
    nagoya: '留学サポート名古屋',
    fukuoka: '留学サポート福岡',
    kumamoto: '留学サポート熊本',
    kagoshima: '留学サポート鹿児島'
  },
  areas: {
    '23': '名古屋',
    '40': '福岡',
    '43': '熊本',
    '46': '鹿児島'
  },
  areaSlugs: {
    nagoya: '名古屋',
    fukuoka: '福岡',
    kumamoto: '熊本',
    kagoshima: '鹿児島'
  },
  offices: {
    23: {
      label: '名古屋',
      slug: 'nagoya',
      document: {
        header: '株式会社SAS',
        footer: '株式会社SAS　留学サポート名古屋',
        address: '〒460-0008 愛知県名古屋市中区栄3-15−33 栄ガスビル 13階',
        phone: 'TEL 052-855-3429',
        email: 'Email sas@ryugakusupport.com'
      },
      account: {
        bank: '三井住友銀行',
        branch: '熊本支店',
        type: '普通',
        number: '0437760',
        name: '株式会社SAS（エスエーエス）'
      }
    },
    40: {
      label: '福岡',
      slug: 'fukuoka',
      document: {
        header: '株式会社SAS',
        footer: '株式会社SAS　留学サポート福岡',
        address: '〒810-0041 福岡県福岡市中央区大名2丁目1-38 The Winds Daimyo2-2階',
        phone: 'TEL 092-982-5427',
        email: 'Email sas@ryugakusupport.com'
      },
      account: {
        bank: '三井住友銀行',
        branch: '熊本支店',
        type: '普通',
        number: '0437760',
        name: '株式会社SAS（エスエーエス）'
      }
    },
    43: {
      label: '熊本',
      slug: 'kumamoto',
      document: {
        header: '株式会社SAS',
        footer: '株式会社SAS　留学サポート熊本',
        address: '〒860-0845 熊本県熊本市中央区上通町6-23 長崎書店ビル2階',
        phone: 'TEL 096-351-8770',
        email: 'Email sas@ryugakusupport.com'
      },
      account: {
        bank: '三井住友銀行',
        branch: '熊本支店',
        type: '普通',
        number: '0437760',
        name: '株式会社SAS（エスエーエス）'
      }
    },
    46: {
      label: '鹿児島',
      slug: 'kagoshima',
      document: {
        header: '株式会社SAS',
        footer: '株式会社SAS　留学サポート鹿児島',
        address: '〒890-0054 鹿児島県鹿児島市荒田2-60-15',
        phone: 'TEL 099-297-6316',
        email: 'Email sas@ryugakusupport.com'
      },
      account: {
        bank: '三井住友銀行',
        branch: '熊本支店',
        type: '普通',
        number: '0437760',
        name: '株式会社SAS（エスエーエス）'
      }
    }
  },
  day: [
    '日', '月', '火', '水', '木', '金', '土'
  ],
  status: {
    db: [
      'hidden',
      'active',
      'done',
      'cancel',
      'suspend'
    ],
    answer: {
      yes: 'はい',
      no: 'いいえ'
    },
    onoff: {
      on: 'ON',
      off: 'OFF'
    },
    author: {
      hidden: '非アクティブ',
      active: 'アクティブ',
      suspended: '保留中'
    }
  },
  sex: {
    M: '男性',
    W: '女性'
  },
  nations: {
    JP: '日本',
    US: 'アメリカ',
    CA: 'カナダ',
    GB: 'イギリス',
    AU: 'オーストラリア',
    NZ: 'ニュージーランド',
    PH: 'フィリピン',
    IE: 'アイルランド',
    TW: '台湾',
    CN: '中国',
    KR: '韓国',
    FR: 'フランス',
    DE: 'ドイツ',
    CH: 'スイス',
    MT: 'マルタ',
    DK: 'デンマーク',
    SG: 'シンガポール',
    ID: 'インドネシア',
    GU: 'グアム',
    AE: 'UAE'
  },
  contacts: {
    mobile: '携帯電話',
    phone: '固定電話',
    email: 'Eメール'
  },
  prefs: {
    '北海道': '北海道',
    '青森県': '青森県',
    '岩手県': '岩手県',
    '宮城県': '宮城県',
    '秋田県': '秋田県',
    '山形県': '山形県',
    '福島県': '福島県',
    '茨城県': '茨城県',
    '栃木県': '栃木県',
    '群馬県': '群馬県',
    '埼玉県': '埼玉県',
    '千葉県': '千葉県',
    '東京都': '東京都',
    '神奈川県': '神奈川県',
    '山梨県': '山梨県',
    '長野県': '長野県',
    '新潟県': '新潟県',
    '富山県': '富山県',
    '石川県': '石川県',
    '福井県': '福井県',
    '岐阜県': '岐阜県',
    '静岡県': '静岡県',
    '愛知県': '愛知県',
    '三重県': '三重県',
    '滋賀県': '滋賀県',
    '京都府': '京都府',
    '大阪府': '大阪府',
    '兵庫県': '兵庫県',
    '奈良県': '奈良県',
    '和歌山県': '和歌山県',
    '鳥取県': '鳥取県',
    '島根県': '島根県',
    '岡山県': '岡山県',
    '広島県': '広島県',
    '山口県': '山口県',
    '徳島県': '徳島県',
    '香川県': '香川県',
    '愛媛県': '愛媛県',
    '高知県': '高知県',
    '福岡県': '福岡県',
    '佐賀県': '佐賀県',
    '長崎県': '長崎県',
    '熊本県': '熊本県',
    '大分県': '大分県',
    '宮崎県': '宮崎県',
    '鹿児島県': '鹿児島県',
    '沖縄県': '沖縄県'
  },
  about: {
    passport: {
      status: {
        YES: '所持',
        PROGRESS: '申請中',
        NO: '未所持'
      }
    },
    visa: {
      types: {
        VISIT: '観光',
        STUDENT: '学生',
        WH: 'ワーホリ',
        WK: '就労'
      },
      status: {
        YES: '所持',
        PROGRESS: '申請中',
        NO: '未所持',
        UNNECESSARY: '不要'
      },
      arrangers: {
        AGENT: '代行依頼',
        SELF: '自己手配'
      }
    },
    langs: {
      english: '英語',
      korean: '韓国語',
      chinese: '中国語',
      french: 'フランス語',
      german: 'ドイツ語'
    },
    career: {
      status: {
        graduating: '卒業予定',
        graduated: '卒業済',
        dropped: '中退'
      }
    },
    medical: {
      status: {
        YES: 'はい',
        PAST: '過去にある',
        NO: 'いいえ'
      }
    },
    smoke: {
      YES: 'はい', NO: 'いいえ'
    },
    allergy: {
      YES: 'はい', NO: 'いいえ'
    },
    homestay: {
      kids: {
        AGE00_05: '0歳〜5歳',
        AGE06_10: '6歳〜10歳',
        AGE11_15: '11歳〜15歳',
        AGE16_: '16歳以上',
        ANY: 'どの年代でも大丈夫'
      },
      pets: {
        YES: 'はい', NO: 'いいえ'
      }
    }
  },
  arrange: {
    types: {
      'prog-short': '短期留学',
      'prog-long': '長期留学',
      'prog-wh': 'ワーホリ',
      'prog-academic': '高校・大学正規留学'
    },
    stay: {
      owners: {
        'nyc-ton': 'NYC-トン',
        'syd-daniel': 'SYD-ダニエル'
      }
    }
  },
  apply: {
    flight: {
      status: {
        ORDER: '当社へ依頼する',
        COMPARE: '比較・検討する',
        SELF: '依頼しない（自己手配）'
      }
    },
    insurance: {
      status: {
        ORDER: '当社へ依頼する',
        COMPARE: '比較・検討する',
        SELF: '依頼しない（自己手配）'
      }
    },
    visa: {
      status: {
        ORDER: '当社手配',
        SELF: '自己手配',
        DONE: '手続き済み',
        SCHOOL: '学校手配',
        UNNECESSARY: '不要'
      }
    },
    pickup: {
      status: {
        SCHOOL: '学校手配',
        SELF: '自己手配',
        THIRD: '外部手配',
        ORDER: '現地サポーター',
        UNNECESSARY: '不要'
      },
      type: {
        oneway: '片道',
        roundtrip: '往復'
      }
    }
  },
  charge: {
    types: {
      school: '学費',
      stay: '滞在費用',
      flight: '航空券代金',
      aviation: '航空券代金',
      insurance: '保険料',
      visa: '査証費用',
      support: 'サポート費用',
      domestic: '国内諸経費',
      others: 'その他'
    }
  },
  bbook: {
    items: {
      payment: '支払',
      deposite: '入金',
      commission: '入金（コミッション）',
      prefund: '返金（マイナス）',
      drefund: '返金',
      dcpayment: '支払（カード）',
      'carry-in': '繰越し',
      'carry-out': '売上計上'
    },
    card: {
      options: {
        0: {
          label: 'DC',
          slug: 'dc',
          flag: 'T'
        },
        1: {
          label: 'LIFE',
          slug: 'life',
          flag: 'T'
        },
        2: {
          label: 'JCB',
          slug: 'jcb',
          flag: 'T'
        }
      }
    },
    dcmeta: {
      labels: {
        school: '学費',
        stay: '滞在費用',
        flight: '航空券代金',
        aviation: '航空券代金',
        avicom: '航空券変更手数料',
        insurance: '保険料',
        visa: '査証費用',
        hotel: 'ホテル代',
        apart: 'アパート代',
        support: '現地サポート代',
        test: 'テスト受験代',
        examfee: '受験料',
        mobile: '携帯電話代',
        computer: 'パソコン代',
        textfee: '参考書代',
        hospital: '病院診察代',
        tour: '現地ツアー代',
        trafic: '現地交通費',
        shipping: '現地荷物発送費',
        uniform: '制服代',
        carry: '繰越代',
        bank_handling: '銀行手数料'
      }
    },
    types: {
      school: '学費',
      stay: '滞在費用',
      flight: '航空券代金',
      aviation: '航空券代金',
      insurance: '保険料',
      visa: '査証費用',
      support: 'サポート費用',
      domestic: '国内諸経費',
      others: 'その他',
      other_private: 'その他（個人費用）',
      other_hs: 'その他（高校留学）',
      bank_handling: '銀行手数料',
      hotel: 'ホテル代',
      apart: 'アパート代',
      test: '受験料',
      examfee: '受験料',
      mobile: '携帯電話代',
      computer: 'パソコン代',
      textfee: '参考書代',
      hospital: '病院診察代',
      tour: '現地ツアー代',
      trafic: '現地交通費',
      shipping: '現地荷物発送費',
      uniform: '制服代',
      carry: '繰越代'
    }
  },
  reminders: {
    '査証': {
      labels: {
        items: [ '申請日', '失効日' ],
        defaults: [ 0 ]
      },
      icon: 'fal fa-passport'
    },
    '航空券': {
      labels: {
        items: [ '出発日', '帰国日', '帰路変更日' ],
        defaults: [ 0 ]
      },
      icon: 'fal fa-plane'
    },
    '保険': {
      labels: {
        items: [ '失効日' ],
        defaults: [ 0 ]
      },
      icon: 'fal fa-book-medical'
    },
    '学校': {
      labels: {
        items: [ '入学日', '修了日', 'ターム開始', 'ターム終了', '送金期限' ],
        defaults: [ 0 ]
      },
      icon: 'fal fa-user-graduate'
    },
    '滞在': {
      labels: {
        items: [ '到着日', '退去日', '更新（延長・変更）期限', '支払期限' ],
        defaults: [ 0 ]
      },
      icon: 'fal fa-home'
    }
  }
}
